import { initQformElements } from './components/_quform-elements.js';
import initQuformFileUpload from './components/_quform-fileupload.js';
import initChangeUploadDropzone from './components/_quform-filedropzone.js';
import initMoveProgressBar from './components/_quform-progressbar.js';
import initQuformPageTransition from './components/_quform-pagetransition.js';
import initQuformValidation from './components/_quform-validation.js';


jQuery(function ($) {

    console.log('hello quform');

    // Quformエレメントの初期化
    initQformElements();

    // ファイルアップロードの処理
    initQuformFileUpload();

    // ファイルアップロードのドロップゾーンデザイン適用
    initChangeUploadDropzone();

    // アップロードのプログレスバーを送信ボタンの上へ移動
    initMoveProgressBar();

    // ページ切替時のイベント
    initQuformPageTransition();

    // カスタムバリデーション
    initQuformValidation();


});

